import React from "react";
import { useImmer } from "use-immer";

import { SxProps } from "@mui/material";

import { IgTooltip } from "./IgTooltip";
import { IgTypography } from "./IgTypography";
import { ColorPrimary } from "./theme";

interface IgTypographyTooltipProps {
  textWidth?: string;
  textMaxWidth?: string;
  text: string;
  textSx?: SxProps;
  noHover?: boolean;
}
export const IgTypographyTooltip = ({
  text,
  textWidth,
  textMaxWidth,
  textSx,
  noHover,
}: IgTypographyTooltipProps) => {
  const [showTooltip, setShowTooltip] = useImmer(false);
  return (
    <IgTooltip title={showTooltip ? text : ""}>
      <IgTypography
        noWrap={true}
        onMouseOver={(e) => {
          if (e.currentTarget.scrollWidth > e.currentTarget.clientWidth) {
            setShowTooltip((draft) => {
              draft = true;
              return draft;
            });
          }
        }}
        onMouseOut={() => {
          setShowTooltip(false);
        }}
        sx={{
          fontSize: "15px",
          overflow: "hidden",
          textOverflow: "ellipsis",
          whiteSpace: "nowrap",
          display: "block",
          maxWidth: textMaxWidth ?? "100%",
          width: textWidth ?? "250px",
          "&:hover": {
            cursor: noHover ? "default" : "pointer",
            color: noHover ? "inherit" : ColorPrimary.main,
          },
          ...textSx,
        }}
        igStyle={"semibold"}
      >
        {text}
      </IgTypography>
    </IgTooltip>
  );
};
